<template>
	<div class='header-logo'>
		<router-link :to="{name: 'home'}" v-if='!nolink'>
			<div class='logo' :class="[$mq.isDesktop() ? 'big' : 'small']"></div>
		</router-link>

		<div class='logo' :class="[$mq.isDesktop() ? 'big' : 'small']" v-if="nolink"></div>
	</div>
</template>

<script>

export default {

	props: {
		nolink: {
			type: Boolean,
			default: false
		}
	},	
}

</script>

<style scoped>
	.header-logo {
		justify-content: center;
		display: flex;
		align-items: center;
	}

</style>
